import { logError as logErrorCore } from '@fiverr-private/identification_core';

const DEFAULT_ENRICHMENT = {
    package: '@fiverr-private/identification_marketplace',
};

export const logError = ({ error, message, enrichment }: Parameters<typeof logErrorCore>[0]) =>
    logErrorCore({
        error,
        message,
        enrichment: {
            ...enrichment,
            ...DEFAULT_ENRICHMENT,
        },
    });
